import { GetListRes } from './GetListRes';

export enum TableColumnKey {
  ID = 'id',
  MERCHANT_NAME = 'merchantName',
  BATCH_ID = 'batchId',
  OPERATION_TYPE = 'operationType',
  CHAIN_NAME = 'chain',
  APPROVAL_PROGRESS = 'approvalProgress',
  TOTAL_OPERATION = 'totalOperation',
  REQUEST_TIME = 'requestTime',
  STATUS = 'status',
  CREATED_BY = 'createdBy',
  CREATED_DATE = 'createdDate',
  LAST_MODIFIED_BY = 'lastModifiedBy',
  LAST_MODIFIED_DATE = 'lastModifiedDate',
  TRANSACTION_OPERATIONS = 'transactionOperations',
}

export interface TableRow {
  [TableColumnKey.ID]: number;
  [TableColumnKey.MERCHANT_NAME]: string;
  [TableColumnKey.BATCH_ID]: number;
  [TableColumnKey.OPERATION_TYPE]: string;
  [TableColumnKey.CHAIN_NAME]: string;
  [TableColumnKey.APPROVAL_PROGRESS]: string;
  [TableColumnKey.TOTAL_OPERATION]: number;
  [TableColumnKey.REQUEST_TIME]: string;
  [TableColumnKey.STATUS]: string;
  [TableColumnKey.CREATED_BY]: string;
  [TableColumnKey.CREATED_DATE]: string;
  [TableColumnKey.LAST_MODIFIED_BY]: string;
  [TableColumnKey.LAST_MODIFIED_DATE]: string;
  [TableColumnKey.TRANSACTION_OPERATIONS]: number;
  rawData: GetListRes;
}
